import VueJwtDecode from "vue-jwt-decode";

export function isTokenExpired(token) {
  const decodedToken =  VueJwtDecode.decode(token);
  const currentTime = Date.now() / 1000;

  return decodedToken.exp < currentTime;
}

export function getTokenExpirationDate(token) {
    const decodedToken =  VueJwtDecode.decode(token);
    return new Date(decodedToken.exp * 1000); // Multiplica por 1000 para convertir de segundos a milisegundos.
}

export function getTokenData(token) {
    return VueJwtDecode.decode(token);
}